<template>
  <Card :showBtn="false" :embedded="embedded">
    <div class="card-uploadPic">
      <div v-if="loading" class="card-loading-overlay">
        <van-loading vertical color="#f4a300">{{
          $t("uploadPic.uploading")
        }}</van-loading>
      </div>
      <div class="card-content">
        <div class="">
          <div class="upload-pic-title">
            <span class="gift-choice-step">2</span>
            <p class="card-title" v-html="$t('uploadPic.title')"></p>
          </div>
          <div class="card-text" v-html="$t('uploadPic.text')"></div>
          <div class="upload-container">
            <div class="upload-box">
              <van-uploader
                v-if="form.fileList.length < 2"
                v-model="form.fileList"
                multiple
                progress
                :max-count="2"
              >
                <div class="upload-btn">
                  <img :src="addPic" />
                  <div class="upload-btn-text">
                    {{ $t("uploadPic.add_pic") }}
                  </div>
                </div>
              </van-uploader>
              <div v-else class="upload-btn upload-btn--disabled">
                <img :src="addPic" />
                <div class="upload-btn-text">{{ $t("uploadPic.add_pic") }}</div>
              </div>
              <div class="upload-text">{{ $t("uploadPic.add_pic_text") }}</div>
            </div>
            <div class="review-upload" v-if="form.fileList.length >= 1">
              <div
                class="review-upload-pic"
                v-for="(item, idx) in form.fileList"
                :key="item.file && item.file.uid != null ? item.file.uid : idx"
              >
                <img :src="item.content" @click="previewPic(item.content)" />
                <van-icon name="cross" @click="deletePic(idx)" />
              </div>
            </div>
          </div>
        </div>
        <div class="upload-guide-section">
          <div class="reference-step-heading" style="margin-top: 20px">
            <!-- <div>
              <p class="card-title" v-html="$t('uploadPic.guideText')"></p>
            </div> -->
            <div>
              <strong>{{ $t("reviewGuide.title") }}</strong>
              <p class="reference-guide-intro">
                {{ $t("reviewGuide.subtitle") }}
              </p>
            </div>
          </div>
          <div class="reference-guide">
            <!-- <strong>{{ $t("reviewGuide.title") }}</strong>
            <p class="reference-guide-intro">
              {{ $t("reviewGuide.subtitle") }}
            </p> -->
            <div class="reference-guide-tabs">
              <button
                v-for="tab in guideTabs"
                :key="tab.key"
                type="button"
                :class="{ active: activeGuide === tab.key }"
                :aria-pressed="activeGuide === tab.key"
                @click.stop.prevent="selectGuide(tab.key)"
              >
                {{ tab.label }}
              </button>
            </div>
            <div class="reference-guide-panel">
              <svg
                class="reference-guide-map"
                viewBox="0 0 720 200"
                role="img"
                :aria-label="activeGuideLabel"
              >
                <rect
                  width="720"
                  height="200"
                  rx="14"
                  fill="#f8fafc"
                  stroke="#e2e8f0"
                />
                <g
                  v-for="n in 4"
                  :key="n"
                  :transform="`translate(${
                    n === 1 ? 24 : n === 2 ? 216 : n === 3 ? 408 : 600
                  },28)`"
                >
                  <rect
                    :width="n === 4 ? 96 : 150"
                    height="144"
                    rx="12"
                    fill="#fff"
                    stroke="#e2e8f0"
                  />
                  <rect
                    :width="n === 4 ? 96 : 150"
                    height="26"
                    rx="12"
                    :fill="guideColor"
                  />
                  <text
                    :x="n === 4 ? 48 : 75"
                    y="18"
                    text-anchor="middle"
                    font-size="12"
                    fill="#fff"
                    font-family="Inter, sans-serif"
                  >
                    {{ guideStepLabels[n - 1] }}
                  </text>
                  <template v-if="n < 3">
                    <rect
                      x="12"
                      y="38"
                      width="126"
                      height="10"
                      rx="5"
                      fill="#e2e8f0"
                    />
                    <rect
                      x="12"
                      y="56"
                      width="90"
                      height="8"
                      rx="4"
                      fill="#eef2f7"
                    />
                    <rect
                      x="12"
                      y="72"
                      width="126"
                      height="8"
                      rx="4"
                      fill="#eef2f7"
                    />
                    <rect
                      x="12"
                      y="110"
                      width="80"
                      height="20"
                      rx="6"
                      :fill="n === 1 ? guideColor : '#f59e0b'"
                    />
                    <g v-if="n === 2" fill="#f59e0b">
                      <path
                        v-for="star in 5"
                        :key="star"
                        :d="`M${
                          20 + (star - 1) * 22
                        } 84 l4 8 9 1 -6.5 6 1.6 9 -8.1 -4.3 -8.1 4.3 1.6 -9 -6.5 -6 9 -1z`"
                      />
                    </g>
                  </template>
                  <g v-else-if="n === 3">
                    <path
                      d="M20 42h100M20 58h78M20 74h110"
                      stroke="#e2e8f0"
                      stroke-width="8"
                      stroke-linecap="round"
                    />
                    <rect
                      x="12"
                      y="90"
                      width="126"
                      height="30"
                      rx="6"
                      fill="#22c55e"
                    />
                  </g>
                  <g v-else>
                    <rect
                      x="16"
                      y="42"
                      width="64"
                      height="64"
                      rx="8"
                      fill="#eef2f7"
                      stroke="#cbd5e1"
                      stroke-dasharray="4 3"
                    />
                    <path d="M32 82l10-12 8 10 8-8 12 18H28z" fill="#94a3b8" />
                  </g>
                  <circle
                    :cx="n === 4 ? 84 : 138"
                    cy="12"
                    r="9"
                    fill="#22c55e"
                  />
                  <text
                    :x="n === 4 ? 84 : 138"
                    y="15"
                    text-anchor="middle"
                    font-size="10"
                    fill="#fff"
                  >
                    {{ n }}
                  </text>
                </g>
                <path
                  d="M182 100h26M374 100h26M566 100h26"
                  stroke="#94a3b8"
                  stroke-width="3"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="card-upload-footer">
        <van-button class="btn-next" :disabled="loading" @click="changeStep">{{
          $t("uploadPic.btn_text")
        }}</van-button>
      </div>
      <p class="done-support">
        {{ $t("thanksAll.supportText") }}
        <a href="mailto:customerservice8@yeah.net">customerservice8@yeah.net</a>
      </p>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/card.vue";
import { postUploadPic } from "@/api/portal";
import { ImagePreview } from "vant";
import { postSubmit } from "@/api/portal";
import { objectToFormData } from "@/utils/tools";
export default {
  components: {
    Card,
  },
  props: {
    embedded: { type: Boolean, default: false },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: { fileList: [] },
      loading: false,
      activeGuide: "walmart",
      examplePic: require("@/assets/example_upload.jpg"),
      addPic: require("@/assets/add-pic.png"),
    };
  },
  mounted() {
    this.form = this.value || {};
    if (!Array.isArray(this.form.fileList))
      this.$set(this.form, "fileList", []);
  },
  computed: {
    guideTabs() {
      return [
        { key: "walmart", label: this.$t("沃尔玛") },
        { key: "bestbuy", label: "Best Buy" },
        { key: "target", label: "Target" },
        { key: "kohls", label: "Kohl's" },
      ];
    },
    activeGuideLabel() {
      return this.guideTabs.find((tab) => tab.key === this.activeGuide).label;
    },
    guideColor() {
      return {
        walmart: "#0071dc",
        bestbuy: "#0046be",
        amazon: "#131921",
        target: "#cc0000",
        kohls: "#43216b",
      }[this.activeGuide];
    },
    guideStepLabels() {
      return {
        walmart: [
          "Walmart.com",
          "Order Details",
          "Rate your purchase",
          "Screenshot",
        ],
        bestbuy: [
          "BestBuy.com",
          "Your Purchases",
          "Write a review",
          "Screenshot",
        ],
        amazon: ["Amazon.com", "Your Orders", "Write a review", "Screenshot"],
        target: ["Target.com", "Orders", "Write a review", "Screenshot"],
        kohls: ["Kohl's.com", "Order History", "Write a review", "Screenshot"],
      }[this.activeGuide];
    },
  },
  methods: {
    selectGuide(key) {
      this.activeGuide = key;
    },
    deletePic(idx) {
      this.form.fileList.splice(idx, 1);
    },
    async continueWithSelectedGift() {
      const gift = this.$parent.selectedGift;
      if (!gift) {
        this.$toast.fail(this.$t("chooseGiftFirst"));
        return;
      }
      this.form.channel_id = gift.id;
      this.form.channel_type = gift.channel_type;
      this.form.channel_pic = gift.channel_pic;
      const nextStep =
        { address: "cityForm", email: "thanksAll", account: "paypalForm" }[
          gift.channel_type
        ] || "thanksAll";
      if (gift.channel_type === "email") {
        try {
          await postSubmit({
            order_id: this.form.order_id,
            area_id: this.form.area_id,
            channel_id: this.form.channel_id,
            nick_name: this.form.nick_name,
            email: this.form.email,
            screenshots: this.form.screenshots,
          });
          this.$parent.changeStep(nextStep, this.form);
        } catch (error) {
          this.$toast.fail(
            (error && error.data && error.data.msg) ||
              this.$t("networkErrorText"),
          );
        }
      } else {
        this.$parent.changeStep(nextStep, this.form);
      }
    },
    changeStep() {
      const files = Array.isArray(this.form.fileList) ? this.form.fileList : [];
      if (files.length) {
        this.loading = true; // 1. 开始加载
        const fileList = files.map((item) => item.file);
        const obj = {
          order_id: this.form.order_id,
          files: fileList,
          email: this.form.email,
        };
        const formData = objectToFormData(obj, ["files"]);
        postUploadPic(formData)
          .then(async (res) => {
            let picList = res.data.map((item) => item);
            this.form.screenshots = picList;
            this.$emit("input", this.form);
            this.$toast.success(this.$t("picUploadSuccessText"));
            await this.continueWithSelectedGift();
          })
          .catch((_) => {
            this.$toast.fail(this.$t("picUploadErrorText"));
          })
          .finally(() => {
            this.loading = false; // 2. 结束加载（无论成功失败）
          });
      } else {
        this.$toast.fail(this.$t("uploadPic.upload_required"));
      }
    },
    previewPic(pic) {
      ImagePreview([pic]);
    },
  },
};
</script>

<style lang="scss">
.card-uploadPic {
  position: relative;
  width: 100%;
  min-height: 200px; // 防止内容为空时高度塌陷

  .card-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0; // 显式增加右边距
    bottom: 0; // 显式增加下边距，确保覆盖到卡片底部
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 99;

    // 居中三剑客
    display: flex;
    justify-content: center; // 水平居中
    align-items: center; // 垂直居中

    border-radius: 8px;
  }
  .van-loading {
    top: 0;
    margin: 0 auto;
  }
  .card-title {
    font-size: 22px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 16px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .upload-container {
    display: flex;
    gap: 9px;
    .upload-box {
      width: 110px;
      .upload-btn {
        width: 100px;
        height: 100px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        border: 1px solid #b3b3b3;
        border-radius: 8px;
        &--disabled {
          background-color: #b3b3b3;
        }
        img {
          height: 40px;
        }
      }
      .upload-btn-text {
        font-size: 11px;
        font-weight: 500;
      }
      .upload-text {
        margin-top: 15px;
        font-size: 11px;
        font-weight: 400;
      }
    }
    .van-uploader__preview {
      display: none;
    }
    .review-upload {
      flex: 1;
      max-width: calc(100% - 110px);
      display: flex;
      flex-direction: column;
      gap: 16px;
      .review-upload-pic {
        position: relative;
        // background: linear-gradient(180deg, #ffd814aa, #ffa031aa);
        // border: 2px solid #909090;
        color: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        padding: 12px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .van-icon-cross {
          position: absolute;
          right: 8px;
          top: 8px;
          width: 22px;
          height: 22px;
          background: #ffffffcf;
          color: #b1afaf;
          border: 1px solid #b1afaf;
          text-align: center;
          line-height: 22px;
          border-radius: 22px;
        }
        img {
          height: 134px;
          width: auto;
          max-width: 100%;
          object-fit: contain;
        }
      }
      .no-data-box {
        min-height: 200px;
        .van-empty__image {
          .van-icon {
            font-size: 159px;
          }
        }
      }
      .custom-empty {
        padding: 0 0 10px 0;
        .van-empty__description {
          margin-top: 0px;
        }
      }
      .example {
        margin-bottom: 10px;
        color: #595959;
      }
      .review-upload-text {
        font-size: 21px;
        font-weight: 500;
        text-align: center;
      }
    }
  }

  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
